<script setup lang="ts">
import { toRefs } from "vue";
import { utc2local } from "@/utils";
import type { Device } from "@/rvapi";
const props = defineProps<{
  device?: Device;
  simple: boolean;
}>();
const { device, simple } = toRefs(props);
</script>

<template>
  <dl v-if="device">
    <dt>Support reference</dt>
    <dd>{{ device.supportRef }}</dd>
    <dt>Created at</dt>
    <dd>{{ utc2local(device.createdAt) }}</dd>
    <dt>Last used at</dt>
    <dd>{{ utc2local(device.lastRegistration) }}</dd>
    <dt>Last logged in user</dt>
    <dd>
      <a v-show="device.userId" :href="'/user/' + device.userId">
        {{ device.userId }}
      </a>
      <span v-show="!device.userId">-</span>
    </dd>
    <dt>Balance</dt>
    <dd>
      {{ device.legacyBalance }}
      <pn-button
        v-show="device.legacyBalance && !simple"
        small="true"
        appearance="warning"
        :href="`/device/${device.deviceId}/migrate`"
      >
        Migrate to user
      </pn-button>
    </dd>
  </dl>
  <dl v-if="device && !simple">
    <dt>App</dt>
    <dd>{{ device.platform }} {{ device.appVersion }}</dd>
    <dt>Device</dt>
    <dd>{{ device.deviceOsVersion }} {{ device.deviceDescription }}</dd>
    <dt>Language</dt>
    <dd>{{ device.language || "-" }}</dd>
    <dt>Location</dt>
    <dd>{{ device.location || "-" }}</dd>
  </dl>
</template>
